export const areObjectsEqual = <T = unknown>(mainObject: T | undefined, newObjectParams: Partial<T>): boolean => {
  if (!mainObject) {
    return false;
  }
  const differencedKeys = Object.keys(newObjectParams).filter((item) => {
    const key = item as keyof T;
    return mainObject[key] !== newObjectParams[key];
  });

  return !differencedKeys.length;
};
